import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page" className="pt-24 sm:pt-28">
      <Seo title="FAQ" description="Answers about Arsenal Artists — pricing, timelines, revisions, files, subscriptions and custom work." path="/faq" />
      <header className="max-w-4xl mx-auto px-5 sm:px-8 pb-12">
        <Eyebrow>FAQ</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">Asked, <span className="text-arsenal">answered.</span></h1>
      </header>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 pb-20">
        <Reveal>
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={`f-${i}`} className="border-white/10">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-display font-semibold text-white hover:text-arsenal">{f.question}</AccordionTrigger>
                <AccordionContent className="text-slate-400 leading-relaxed">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-14 border border-white/10 bg-ink-surface p-8 text-center">
            <p className="text-slate-300">Still not sure? Tell us what you're building.</p>
            <Link to="/start-a-project" data-testid="faq-start-project" className="clip-btn mt-5 inline-flex items-center gap-2 bg-arsenal hover:bg-arsenal-bright text-white font-display font-bold tracking-widest text-sm px-7 py-3.5 transition-colors">
              START A PROJECT <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
